import { FCC, JarvisCookieAuthProvider, useDynamicConfig } from "@dgs/core";

export const JarvisAuthProvider: FCC = ({ children }) => {
	const { authUrl } = useDynamicConfig();

	return <JarvisCookieAuthProvider authUrl={authUrl}>{children}</JarvisCookieAuthProvider>;
};
